import { createContext, type ReactNode, useContext } from 'react';

import { useBidExpiryTimer } from '../../hooks';

interface ExpiryContextValue {
  isBidExpired: boolean;
}

const defaultValue: ExpiryContextValue = {
  isBidExpired: false,
};

export const ExpiryContext = createContext<ExpiryContextValue>(defaultValue);

interface ExpiryProviderProps {
  children: ReactNode;
  bidExpiryDateTime: string;
}

export const ExpiryProvider = ({ children, bidExpiryDateTime }: ExpiryProviderProps) => {
  const { isBidExpired } = useBidExpiryTimer(bidExpiryDateTime);

  return <ExpiryContext.Provider value={{ isBidExpired }}>{children}</ExpiryContext.Provider>;
};

export const useExpiryContext = () => {
  const context = useContext(ExpiryContext);

  if (!context) {
    throw new Error('useExpiryContext must be used within ExpiryProvider');
  }

  return context;
};
